import React, {useContext, useEffect} from 'react';
import {Select} from 'antd';
import {sideMenuContext} from '../../../router/IndexRouter';
import {Arguments} from '../common/Arguments';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';
import {SortByOrganizationPost} from '../common/SortListByPost';

const MeetingDelegateAdmin = () => {
	const {dataSource, setDataSource, copyDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/home/api!organizationMeetingDelegate.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 80,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '届次',
			dataIndex: 'meeting_term_name',
			width: 80,
		},
		{
			title: '社会组织',
			dataIndex: 'organization_name',
			width: 180,
		},
		{
			title: '姓名',
			dataIndex: 'member_name',
			width: 80,
			sorter: (a, b) => a.member_name.localeCompare(b.member_name),
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '性别',
			dataIndex: 'member_sex',
			width: 70,
		},
		{
			title: '出生日期',
			dataIndex: 'member_born',
			width: 110,
		},
		{
			title: '民族',
			responsive: ['lg'],
			dataIndex: 'member_mz',
			width: 70,
		},
		{
			title: '政治面貌',
			dataIndex: 'member_zzmm',
			width: 100,
		},
		{
			title: '社团职务',
			dataIndex: 'organization_post',
			width: 120,
		},
		{
			title: '工作单位（或原）',
			responsive: ['lg'],
			dataIndex: 'member_unit',
			width: 200,
		},
		{
			title: '职务',
			responsive: ['lg'],
			dataIndex: 'member_post',
			width: 130,
		},
		{
			title: '职称',
			responsive: ['lg'],
			dataIndex: 'member_professional',
			width: 70,
		},
		{
			title: '大会职务',
			responsive: ['lg'],
			dataIndex: 'meeting_member_post',
			width: 100,
		},
		{
			title: '手机号',
			dataIndex: 'member_mobile_phone',
			width: 120,
		},
	];

	const onSearch = (section) => {
		if (section !== '全部') {
			const filterData = copyDataSource.filter(item =>
				item.meeting_term_name === section,
			);
			setDataSource(filterData);
		} else {
			setDataSource(copyDataSource);
		}
	};

	const newData = dataSource.map(
		(
			{
				organization_name,
				meeting_term_name,
				member_name,
				member_sex,
				member_born,
				member_mz,
				member_zzmm,
				member_educational,
				organization_post,
				member_unit,
				member_post,
				member_professional,
				meeting_member_post,
				member_sfz,
				member_mobile_phone,
			},
		) => (
			{
				'社会组织': organization_name,
				'届次': meeting_term_name,
				'姓名': member_name,
				'性别': member_sex,
				'出生日期': member_born,
				'民族': member_mz,
				'政治面貌': member_zzmm,
				'文化程度': member_educational,
				'社团职务': organization_post,
				'工作单位': member_unit,
				'职务': member_post,
				'职称': member_professional,
				'大会职务': meeting_member_post,
				'身份证号': member_sfz,
				'手机号': member_mobile_phone,
			}
		),
	);

	const indexDataSource = SortByOrganizationPost(dataSource).map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<span style={{marginLeft: 5}}>大会届次：</span>
			<Select style={{width: 200, marginRight: 15}} onChange={onSearch} defaultValue="全部">
				<Select.Option value="全部">全部</Select.Option>
				<Select.Option value="第五届">第五届</Select.Option>
				<Select.Option value="第六届">第六届</Select.Option>
				<Select.Option value="第七届">第七届</Select.Option>
				<Select.Option value="第八届">第八届</Select.Option>
				<Select.Option value="第九届">第九届</Select.Option>
				<Select.Option value="第十届">第十届</Select.Option>
				<Select.Option value="第十一届">第十一届</Select.Option>
			</Select>
			<ExportToExcel tableData={newData}/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
};

export default MeetingDelegateAdmin;

